import * as Yup from "yup";
import {
  ComplaintMaterialSelectionType,
  ComplaintMaterialWarrantyStatus,
} from "features/ComplaintMaterials/constants/complaint-material.constants";

const schema = Yup.object({
  clientId: Yup.number()
    .typeError("Client is required")
    .required("Client is required"),

  selectionType: Yup.mixed<ComplaintMaterialSelectionType>()
    .oneOf(Object.values(ComplaintMaterialSelectionType))
    .required("Selection type is required"),

  /** Required unless selectionType is OTHER. Transform empty string to null first. */
  materialId: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? null : value,
    )
    .nullable()
    .when("selectionType", {
      is: ComplaintMaterialSelectionType.OTHER,
      then: (s) => s.nullable(),
      otherwise: (s) =>
        s.typeError("Material is required").required("Material is required"),
    }),

  /** Required when selectionType is OTHER. */
  name: Yup.string()
    .nullable()
    .when("selectionType", {
      is: ComplaintMaterialSelectionType.OTHER,
      then: (s) => s.trim().required("Item name is required"),
      otherwise: (s) => s.nullable(),
    }),

  manufacturer: Yup.string().nullable(),
  serialNo: Yup.string().nullable(),
  purchaseDate: Yup.string().nullable(),

  warrantyStatus: Yup.mixed<ComplaintMaterialWarrantyStatus>()
    .oneOf(Object.values(ComplaintMaterialWarrantyStatus))
    .required("Warranty status is required"),

  complaintReceivedDate: Yup.string().nullable(),

  complaintDescription: Yup.string()
    .trim()
    .required("Complaint description is required"),

  remarks: Yup.string().nullable(),

  /** Lifecycle dates — no ordering enforced, any of them may be set/cleared freely. */
  resolvedDate: Yup.string().nullable(),
  dateOfDispatch: Yup.string().nullable(),
  dateHandedBackToClient: Yup.string().nullable(),
});

export default schema;
